/**
 * Floating Video Module
 * @module floatingVideo
 */

import $ from 'jquery';
import './custom-video-player';
import registerJQueryPlugin from '../../lib/register-jquery-plugin';
import mergeOptions from '../../lib/merge-options';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'floatingVideo';
export const DEFAULTS = {
  // filled: 0,
  videoMuted: true,
};

const returnVideoContainerHTML = (videoUrl, videoPosterUrl) => $(`
  <div id="js-floating-video-container" class="floating-video__container">
    <button class="floating-video__close js-floating-video__close" type="button">
        <span class="icon icon--x icon--sm">
          <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
            <path
              d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z">
            </path>
          </svg>
          <div class="u-screen-reader">Close Modal</div>
        </span>
    </button>
    <video class="u-full-width" poster="${videoPosterUrl}" playsinline="playsinline" loop>
      <source src="${videoUrl}" type="video/mp4">
    </video>
  </div>
`);

/**
 * Sets the calculated attributes to each of the <circle> elements in the
 * progress ring module
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const showVideo = ($el, options) => {
  const videoUrl = $el.data('videoUrl');
  const videoPosterUrl = $el.data('videoPosterUrl');
  const $floatingContainer = returnVideoContainerHTML(videoUrl, videoPosterUrl);
  const $video = $floatingContainer.find('video');
  const $closeButton = $floatingContainer.find('.js-floating-video__close');

  // remove existing player if one already exists
  $('#js-floating-video-container').remove();
  $('body').append($floatingContainer);


  // Close Button Listener
  $closeButton.on('click', function () {
    $floatingContainer.remove();
  });

  $video.customVideoPlayer(options);
}

/**
 * Initializes floatingVideo
 * @param {HTMLElement} el - thumbnail
 * @param {Object} options - Options used for wiring up the floatingVideo
 * @see DEFAULTS
 */
export default function floatingVideo(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);

  $el.on('click', () => {
    showVideo($el, opts);
  })
  
  return {
    // rerender: (filled, pending) => rerender($el, filled, pending, opts),
  };
}
registerJQueryPlugin(PLUGIN_NAME, floatingVideo);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/abtest/floating-video.js